import { Image, StyleSheet, Text, View } from "@react-pdf/renderer";
import DesignConstants from "../../../constants/DesignConstants";
import { GoodLuckNames } from "../../../enums/settings";
import { getGoodLuckImgSource } from "../../../helpers/GoodLuckHelper";

interface PDFGoodLuckImageProps {
    goodLuckText: string;
    goodLuckImageName: GoodLuckNames;
    isInHeader?: boolean;
    isInHeaderTopRow?: boolean;
}

export const PDFGoodLuckImage = (props: PDFGoodLuckImageProps) => {
    const dynamicWidth = props.isInHeaderTopRow
        ? DesignConstants.PDF.GAP_L
        : props.isInHeader
        ? DesignConstants.PDF.GAP_XL
        : "3.5cm";

    const image = getGoodLuckImgSource(props.goodLuckImageName);
    if (!image) return null;

    return (
        <View
            style={{
                ...styles.goodLuckWrapper,
                flexDirection: props.isInHeaderTopRow ? "row" : "column",
                gap: props.isInHeaderTopRow ? DesignConstants.PDF.GAP_XS : DesignConstants.PDF.GAP_XXS,
                minWidth: dynamicWidth,
                height: !props.isInHeader ? "100%" : "auto"
            }}
            wrap={false}
        >
            <View style={styles.goodLuckTextWrapper}>
                <Text style={styles.goodLuckText}>{props.goodLuckText}</Text>
            </View>
            <View style={styles.goodLuckImageWrapper}>
                <Image
                    src={image}
                    style={{
                        ...styles.goodLuckImage,
                        width: dynamicWidth,
                    }}
                />
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    goodLuckWrapper: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        border: DesignConstants.BORDERS.MEDIUM,
    },
    goodLuckTextWrapper: {
        maxWidth: "4cm",
    },
    goodLuckText: {
        textAlign: "center",
        flexWrap: "wrap",
        fontSize: DesignConstants.PDF.FONTSIZE_REGULAR,
        fontWeight: DesignConstants.FONT_WEIGHTS.BOLD,
    },
    goodLuckImageWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    goodLuckImage: {
        objectFit: "contain",
    },
});

export default PDFGoodLuckImage;
